import { render, staticRenderFns } from "./StreamerDashboard.vue?vue&type=template&id=4687d789&"
import script from "./StreamerDashboard.vue?vue&type=script&lang=js&"
export * from "./StreamerDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports